import React, { useEffect, useMemo, useState } from "react";
import "./Thevvatapprint.css";
import axios from "axios";

import { Document, Page, Text, View, StyleSheet, PDFViewer } from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

// Register fonts
Font.register({
  family: "Lato-Italic",
  src: LatoItalicFont,
});

Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});

const createStyles = (fontBase) =>
  StyleSheet.create({
    page: {
      marginTop: 20,
      paddingTop: 10,
      paddingBottom: 50,
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    header: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      textAlign: "center",
    },
    tableContainer: {
      display: "flex",
      flexDirection: "row",
      width: "100vw",
      justifyContent: "space-between",
    },
    table: {
      display: "table",
      width: "97%",
      margin: 5,
      marginTop: 15,
    },
    tableone: {
      display: "table",
      width: "18%",
      margin: 5,
    },
    tableCellone: {
      border: "0.5px solid black",
      padding: 0.5,
      fontSize: 8,
      fontFamily: fontBase,
      textAlign: "center",
      flex: 1,
    },
    tableRowone: {
      flexDirection: "row",
      width: "100%",
    },
    tableHeaderone: {
      fontFamily: fontBase,
      fontWeight: "bold",
      border: "1px solid #000",
      padding: 2,
      fontSize: 8,
      textAlign: "center",
      flex: 1,
    },

    tableRowcell: {
      flexDirection: "row",
      marginBottom: 1,
      flexGrow: 1,
    },

    tableRowcelld2: {
      paddingLeft: 100,
      paddingRight: 20,
      flexDirection: "row",
      height: 50,
      marginBottom: 1,
      flexGrow: 1,
    },

    secondlayout: {
      paddingLeft: 50,
      marginLeft: 100,
      flexDirection: "row",
      height: 100,
      marginBottom: 1,
      flexGrow: 1,
    },

    tableRowd2: {
      backgroundColor: "lightgray",
      flexDirection: "row",
      marginBottom: 1,
      flexGrow: 1,
    },
    tableRow2d2: {
      flexDirection: "row",
      backgroundColor: "black",
      marginTop: 5,
    },

    tableRow3d2: {
      flexDirection: "row",
      backgroundColor: "lightgray",
      marginTop: 10,
      marginBottom: 50,
    },

    tableRow: {
      backgroundColor: "lightgray",
      flexDirection: "row",
      marginBottom: 1,
      flexGrow: 1,
    },
    tableRow2: {
      flexDirection: "row",
      backgroundColor: "black",
      marginTop: 5,
    },
    hr: {
      height: 1,
      backgroundColor: "#d3d3d3",
      width: "95%",
      marginVertical: 8,
      marginLeft: 20,
      marginRight: 10,
    },

    tableRow3: {
      flexDirection: "row",
      backgroundColor: "lightgray",
      marginTop: 10,
      marginBottom: 50,
    },
    line: {
      flexDirection: "row",
      backgroundColor: "black",
      marginTop: 5,
      height: 1,
      width: "100vw",
      marginBottom: 5,
    },
    tableHeader: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      borderStyle: "solid",
      padding: 2,
      flex: 0.5,
      borderColor: "black",
      textAlign: "center",
      fontSize: 9,
    },
    tableHeader2: {
      fontFamily: fontBase,
      fontWeight: "bold",
      paddingLeft: 10,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      borderStyle: "solid",
      padding: 2,
      flex: 0.53,
      borderColor: "black",
      textAlign: "center",
      fontSize: 10,
    },
    tableHeaderlast: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderStyle: "solid",
      borderColor: "black",
      padding: 2,
      flex: 0.5,
      textAlign: "center",
      fontSize: 9,
    },
    tableCell: {
      border: "0.5px solid black",
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      width: 2,
      textAlign: "center",
    },
    tableCelld2: {
      padding: 0.5,
      flex: 1,
      fontFamily: fontBase,
      width: 2,
      textAlign: "left",
      fontSize: 10,
      lineHeight: 1.3,
    },
    tableCellleft: {
      border: "0.5px solid black",
      padding: 1,
      paddingLeft: 10,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      width: 2,
      textAlign: "left",
    },
    tableCellgreen: {
      border: "0.5px solid black",
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontWeight: "bold",
      fontFamily: fontBase,
      color: "green",
      width: 2,
      textAlign: "center",
    },
    tableCellred: {
      border: "0.5px solid black",
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontWeight: "bold",
      fontFamily: fontBase,
      color: "red",
      width: 2,
      textAlign: "center",
    },
    latoTextlarge: {
      fontFamily: fontBase,
      fontSize: 15,
      marginBottom: 5,
      textAlign: "center",
      width: "100vw",
      fontWeight: "bold",
      marginTop: 5,
    },
    latoText: {
      fontFamily: fontBase,
      fontSize: 14,
      textAlign: "center",
      width: "100vw",
      fontWeight: "bold",
      marginTop: 5,
    },
    latoText2: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "center",
      width: "100vw",
      fontWeight: "bold",
    },
    headtextsmall: {
      fontFamily: fontBase,
      fontSize: 10,
      fontWeight: "bold",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      width: "100vw",
    },
    row1: {
      display: "flex",
      flexDirection: "row",
      width: "100vw",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: 5,
      paddingRight: 5,
    },
    row2: {
      display: "flex",
      flexDirection: "row",
      width: "100vw",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: 140,
      paddingRight: 140,
      backgroundColor: "black",
    },
    column1: {
      display: "flex",
      flexDirection: "column",
      width: "19%",
      justifyContent: "start",
      alignItems: "flex-start",
      paddingLeft: 5,
      paddingRight: 5,
      marginLeft: 20,
    },
    column2: {
      display: "flex",
      flexDirection: "column",
      width: "15%",
      justifyContent: "start",
      alignItems: "flex-start",
      paddingLeft: 5,
      paddingRight: 5,
    },
    tableCelld2SecondLine: {
      marginTop: 10,
      marginLeft: 12,
      flexDirection: "column",
    },
    tableCelld2Label: {
      fontWeight: "bold",
    },
    tableCelld2Amount: {
      marginTop: 2,
      fontSize: 12,
      fontFamily: fontBase,
    },
    secondLabel: {
      fontFamily: fontBase,
      fontWeight: "bold",
    },
    column3: {
      display: "flex",
      flexDirection: "column",
      width: "17%",
      justifyContent: "start",
      alignItems: "flex-start",
      paddingLeft: 5,
      paddingRight: 5,
      marginLeft: 20,
    },
    column1Row: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    column1Rowgray: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: 6,
      marginTop: 5,
      border: "0.5px solid black",
      backgroundColor: "black",
    },
    column1Label: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: "bold",
      textAlign: "left",
    },
    column1Value: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: "bold",
      textAlign: "right",
    },
    pageBreak: {
      pageBreakBefore: "always",
    },
    totalsRow: {
      flexDirection: "row",
      borderTop: "1px solid #000",
      paddingTop: 5,
      paddingLeft: 2,
    },
    totalsCell: {
      border: "0.5px solid black",
      padding: 0.5,
      flex: 1,
      fontSize: 8,
      width: 2,
      textAlign: "center",
      fontFamily: fontBase,
    },
    imagerow: {
      display: "flex",
      flexDirection: "row",
      width: "100vw",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: 80,
      height: "auto",
      marginLeft: -15,
      marginTop: 5,
    },
    imgtext: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: "bold",
      textAlign: "center",
    },
  });

const Thevvatapprint = () => {
  const { t, i18n } = useTranslation();

  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";
  const styles = useMemo(() => createStyles(fontBase), [fontBase]);

  const [customerData, setCustomerData] = useState([]);

  let totals = {};

  const jsEncode = {
    encode: function (s, k) {
      let enc = "";
      const str = s.toString();
      for (let i = 0; i < str.length; i++) {
        const a = str.charCodeAt(i);
        const b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  useEffect(() => {
    const mainuser2 = jsEncode.encode("mamapr", 125);

    let rawData = {
      bill10type: localStorage.getItem("bill10type"),
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      mainuser: localStorage.getItem("contact"),
      thevtype: localStorage.getItem("thevtype"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);
    const formData = new FormData();
    formData.append("data", rawData);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getthevregister2.php", formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        setCustomerData(Array.isArray(response.data) ? response.data : []);
      })
      .catch((err) => {
        console.log(err);
        setCustomerData([]);
      });
  }, []);

  function formatDate(inputDate) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(inputDate).toLocaleDateString("en-US", options);
  }

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const recordsPerPage = Math.max(1, parseInt(localStorage.getItem("records") || "10", 10));

  const safeNumber = (v) => {
    const n = Number(String(v ?? 0).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  const getThevTypeLabel = () => {
    const thevtype = localStorage.getItem("thevtype");

    if (thevtype === "regular") {
      return t("thevvatapprint.types.regular");
    }
    if (thevtype === "thev1") {
      return localStorage.getItem("itr1name") || "";
    }
    if (thevtype === "thev2") {
      return localStorage.getItem("itr2name") || "";
    }
    if (thevtype === "thev3") {
      return localStorage.getItem("itr3name") || "";
    }
    return "";
  };

  if (Array.isArray(customerData) && customerData.length > 0) {
    totals = {
      ttthev: customerData.reduce((total, rowData) => total + safeNumber(rowData.thevamt), 0),
    };
  }

  const filteredRows = Array.isArray(customerData)
    ? customerData.filter((r) => safeNumber(r.thevamt) > 0)
    : [];

  return (
    <PDFViewer className="pdf">
      <Document>
        {filteredRows.length > 0
          ? chunk(filteredRows, recordsPerPage).map((pageRows, pageIndex, pages) =>
              localStorage.getItem("printdesign") === "1" ? (
                <Page key={pageIndex} size="A4" style={styles.page}>
                  <Text style={styles.latoText}>{localStorage.getItem("kendra")}</Text>

                  <Text style={styles.latoText2}>
                    {t("thevvatapprint.header.title", {
                      type: getThevTypeLabel(),
                    })}
                  </Text>

                  <Text style={styles.latoText2}>
                    {t("thevvatapprint.header.period", {
                      from: formatDate(localStorage.getItem("date1print")),
                      to: formatDate(localStorage.getItem("date2print")),
                    })}
                  </Text>

                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <Text style={styles.tableHeader}>{t("thevvatapprint.table.accountNo")}</Text>
                      <Text style={styles.tableHeader2}>{t("thevvatapprint.table.name")}</Text>
                      <Text style={styles.tableHeader2}>{t("thevvatapprint.table.bankAccount")}</Text>
                      <Text style={styles.tableHeaderlast}>{t("thevvatapprint.table.totalDepositAmount")}</Text>
                      <Text style={styles.tableHeaderlast}>{t("thevvatapprint.table.signature")}</Text>
                    </View>

                    {pageRows.map((rowData, index) => (
                      <View key={index} style={styles.tableRowcell}>
                        <Text style={styles.tableCell}>{rowData.kno}</Text>
                        <Text style={styles.tableCellleft}>{rowData.cname}</Text>
                        <Text style={styles.tableCellleft}>{rowData.accno}</Text>
                        <Text style={styles.tableCell}>
                          {safeNumber(rowData.thevamt).toFixed(2)}
                        </Text>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    ))}

                    {pageIndex === pages.length - 1 && (
                      <View style={styles.tableRow3}>
                        <Text style={styles.tableHeader}>{t("thevvatapprint.table.total")}</Text>
                        <Text style={styles.tableHeader2}>{t("thevvatapprint.table.dash")}</Text>
                        <Text style={styles.tableHeader2}>{t("thevvatapprint.table.dash")}</Text>
                        <Text style={styles.tableHeaderlast}>{safeNumber(totals.ttthev).toFixed(2)}</Text>
                        <Text style={styles.tableHeaderlast}>{t("thevvatapprint.table.signature")}</Text>
                      </View>
                    )}
                  </View>
                </Page>
              ) : (
                <Page key={pageIndex} size="A4" style={styles.page}>
                  <Text style={styles.latoText}>{localStorage.getItem("kendra")}</Text>

                  <Text style={styles.latoText2}>
                    {t("thevvatapprint.header.title", {
                      type: getThevTypeLabel(),
                    })}
                  </Text>

                  <Text style={styles.latoText2}>
                    {t("thevvatapprint.header.period", {
                      from: formatDate(localStorage.getItem("date1print")),
                      to: formatDate(localStorage.getItem("date2print")),
                    })}
                  </Text>

                  <View style={styles.hr} />

                  <View style={styles.table}>
                    {pageRows.map((rowData, index) => (
                      <React.Fragment key={index}>
                        <View style={styles.tableRowcelld2}>
                          <Text style={styles.tableCelld2}>
                            {rowData?.kno}     {rowData?.cname}
                            {
                              "\n\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                            }
                            <Text style={styles.secondLabel}>
                              {t("thevvatapprint.table.totalDepositAmount")}
                            </Text>
                            {
                              "\n\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                            }
                            <Text style={styles.tableCelld2Amount}>
                              {safeNumber(rowData?.thevamt).toFixed(2)}
                            </Text>
                          </Text>
                        </View>
                        <View style={styles.hr} />
                      </React.Fragment>
                    ))}
                  </View>
                </Page>
              )
            )
          : ""}
      </Document>
    </PDFViewer>
  );
};

export default Thevvatapprint;